import { useState } from "react";

import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import { withQueryparams } from "@/main/components/core/queryParams/queryparams";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { getTranslateByKey } from "@/main/services/utils";

// COMPONENTS & STYLES LOCAL
import FiltersRequoteTraceability from "./filtersRequoteTraceability/filtersRequoteTraceability";
import GridRequoteTraceability from "./components/requoteTraceabilityGrid";
import { SearchGridRequoteTraceabilityRequest } from "@/main/models/request/";
import { SearchGridRequoteTraceabilityResponse } from "@/main/models/response";

function RequoteTraceabilityScreen() {
	const [dataGrid, setDataGrid] = useState<SearchGridRequoteTraceabilityResponse[]>([]);
	const [formFilters, setFormFilters] = useState<SearchGridRequoteTraceabilityRequest | null>(null);

	function onResetSearch() {
		setDataGrid([]);
		setFormFilters(null);
	}

	async function getDataGrid(
		filters: SearchGridRequoteTraceabilityRequest | Partial<SearchGridRequoteTraceabilityRequest> = {},
		isResetSearch: boolean = true,
	) {
		const request: SearchGridRequoteTraceabilityRequest = {
			...(isResetSearch ? {} : formFilters),
			...(filters as SearchGridRequoteTraceabilityRequest),
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
		};

		onResetSearch();
		setFormFilters(request);
	}

	const titlePage = `${getTranslateByKey("module.report")} > ${getTranslateByKey("screen.traceabilityreport")}`;
	return (
		<ContainerScreen title={titlePage}>
			<FiltersRequoteTraceability formFilters={formFilters} getDataGrid={getDataGrid} onResetSearch={onResetSearch} />
			<GridRequoteTraceability formFilters={formFilters} dataGrid={dataGrid} setDataGrid={setDataGrid} />
		</ContainerScreen>
	);
}

export default withQueryparams(RequoteTraceabilityScreen);
